import { RewardsComingSoon } from "@/components/rewards/RewardsComingSoon";

/**
 * Dormant SPIF claim form — parked behind the Rewards "coming soon" placeholder
 * (CHP-430) so a direct URL never surfaces the old SpifClaimForm. The form
 * component stays on disk (components/spifs/SpifClaimForm) for later revival.
 * Rewards is NOT cancelled — see ADR-0033 (supersedes ADR-0031 §4).
 */
export function PartnerSpifsNewRoute() {
  return <RewardsComingSoon audience="partner" />;
}
